/**
 * [INPUT]: 依赖 index.css 的 cms-* 结构契约、motion 的 PagePanel 画卷令牌与 cn
 * [OUTPUT]: 对外提供全路由共用 PagePanel，以及 Page/PageHeader/PageTitle/PageDescription/PageActions/PageToolbar/PageSection
 * [POS]: zinnercms-design-system/patterns 的页面骨架；PagePanel 是认证工作区唯一白纸/滚动/切页容器，其内容纸面跟随文档自然高度以保证长页持续绘制
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { m as Motion } from 'framer-motion'

import { cn } from "@/zinnercms-design-system/lib/utils"
import { TRANSITION, VARIANTS } from '@/zinnercms-design-system/motion/motion'

function PagePanel({
  panelKey,
  className,
  viewportClassName,
  children,
  ...props
}) {
  return (
    <section
      data-slot="page-panel"
      className={cn(
        'relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-2xl border border-l-0 border-border/80 bg-card shadow-sm sm:rounded-[1.35rem]',
        className
      )}
      aria-label="管理内容"
      {...props}
    >
      <div
        data-slot="page-panel-viewport"
        className={cn(
          'min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-contain p-4 sm:p-5 lg:p-6',
          viewportClassName
        )}
      >
        <Motion.div
          key={panelKey}
          data-slot="page-panel-sheet"
          className="relative min-h-full min-w-0 bg-card"
          initial="initial"
          animate="animate"
          variants={VARIANTS.pagePanel}
          transition={TRANSITION.pageUnfurl}
        >
          {children}
        </Motion.div>
      </div>
    </section>
  )
}

function Page({ className, ...props }) {
  return <div data-slot="page" className={cn("cms-page", className)} {...props} />
}

function PageHeader({ className, ...props }) {
  return <header data-slot="page-header" className={cn("cms-page-header", className)} {...props} />
}

function PageTitle({ className, ...props }) {
  return <h1 data-slot="page-title" className={cn("cms-page-title", className)} {...props} />
}

function PageDescription({ className, ...props }) {
  return (
    <p
      data-slot="page-description"
      className={cn("cms-page-description", className)}
      {...props}
    />
  )
}

function PageActions({ className, ...props }) {
  return (
    <div
      data-slot="page-actions"
      className={cn("cms-page-actions", className)}
      {...props}
    />
  )
}

function PageToolbar({ className, ...props }) {
  return <div data-slot="page-toolbar" className={cn("cms-toolbar", className)} {...props} />
}

function PageSection({ className, ...props }) {
  return <section data-slot="page-section" className={cn("cms-section", className)} {...props} />
}

export {
  Page,
  PageActions,
  PageDescription,
  PageHeader,
  PagePanel,
  PageSection,
  PageTitle,
  PageToolbar,
}
